module.exports = __webpack_public_path__ + "static/media/boton-noregistrado.ec544664.svg";